module.exports = __webpack_public_path__ + "img/series_crystal_pattern.7785c73b.png";